module.exports = __webpack_public_path__ + "img/ideesbleues 2023.afe85bcc.webp";